import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TenantService } from '../../../services/tenant.service';
import { ToastService } from '../../../services/toast.service';
import { SidebarService } from '../../../services/sidebar.service';

@Component({
    selector: 'app-pay-receipt',
    templateUrl: './receipt.component.html',
    styleUrls: ['./receipt.component.scss'],
    standalone: false
})
export class ReceiptComponent {
    orderId: string | null = null;
    txId: string | null = null;
    amount: number | null = null;
    tenantId: string | null = null;
    tenantKey: string | null = null;
    date = new Date();

    constructor(
        private router: Router,
        private tenantService: TenantService,
        private toastService: ToastService,
        private sideBarService: SidebarService
    ) {
        const state = this.router.getCurrentNavigation()?.extras?.state as any;
        this.orderId = state?.orderId ?? null;
        this.txId = state?.txId ?? null;
        this.amount = state?.amount ?? null;
        this.tenantId = this.tenantService.getTenantId();
        this.tenantKey = this.tenantService.getTenantKey();
    }

    backHome() {
        // navigate to tenant home
        const path = ['/', this.tenantKey || ''];
        this.router.navigate(path);
    }

    async copyTxId() {
        if (!this.txId) return;
        try {
            await navigator.clipboard.writeText(this.txId);
            this.toastService.success('Transaction ID copied to clipboard');
        } catch (err) {
            console.error('copy failed', err);
            this.toastService.info('Copy failed — please copy manually: ' + this.txId);
        }
    }

    print() {
        // Hide the sidebar first and allow Angular to apply the change to the DOM
        this.sideBarService.hide();

        const restore = () => {
            try { this.sideBarService.show(); } catch (e) { /* noop */ }
            try { window.removeEventListener('afterprint', restore); } catch (e) { /* noop */ }
        };

        try {
            // prefer afterprint event when available
            window.addEventListener('afterprint', restore);

            // Defer printing to the next animation frame so the DOM updates (sidebar hidden) are painted
            // Some browsers need a small timeout for CSS/sticky headers to settle; 50ms is a safe compromise.
            requestAnimationFrame(() => setTimeout(() => window.print(), 50));

            // fallback: if afterprint doesn't fire, restore after 2s
            setTimeout(restore, 2000);
        } catch (err) {
            console.error('print failed', err);
            restore();
        }
    }
}